module.exports = __webpack_public_path__ + "img/GENIO_welcome.f91841e6.svg";